import { render, staticRenderFns } from "./CuentasBancariasComponent.vue?vue&type=template&id=0c4dcb91&"
import script from "./CuentasBancariasComponent.vue?vue&type=script&lang=js&"
export * from "./CuentasBancariasComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports